module.exports = __webpack_public_path__ + "components/MapNav/icons/klucz.png?c3a18e6f";


//////////////////
// WEBPACK FOOTER
// ./components/MapNav/icons/klucz.png
// module id = 2080
// module chunks = 0